import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | CHOICE] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | CHOICE] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | CHOICE] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | CHOICE] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | CHOICE] Add Entity',
  UpdateEntity = '[STORE | ENTITY | CHOICE] Update Entity',
  RemoveEntity = '[STORE | ENTITY | CHOICE] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | CHOICE] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | CHOICE] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | CHOICE] Clean Up Snapshots',
  RearrangeChoices = '[STORE | ENTITY | CHOICE] Rearrange Choices',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.ChoiceEntityModels.Choice> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.ChoiceEntityModels.Choice> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.ChoiceEntityModels.Choice> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Rearrange Choices
 */
export class RearrangeChoices {
  public static readonly type = ActionTypes.RearrangeChoices;

  public constructor(public question: FlatModels.QuestionEntityModels.QuestionEntityType,
                     public choices: FlatModels.ChoiceEntityModels.Choice[] | string[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>